import { X } from 'lucide-react';
import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';

import { TrackedButton } from '@Components/ui-v2/tracked-button';
import { AttachmentItem } from '../../../CustomHooks/Agents/useAttachments';
import { AGENT_DURATIONS, AGENT_EASING } from '../../../Helpers/Agents/animations';
import { mimeTypeForName } from '../../../Helpers/Agents/attachments';
import FileCard from '../../FileDownloadButton/FileCard';

interface AttachmentTileProps {
  item: AttachmentItem;
  onRemove: (id: string) => void;
}

/** A file waiting in the composer, removable until it is sent. */
const AttachmentTile = ({ item, onRemove }: AttachmentTileProps) => {
  const { t } = useTranslation();
  const { file } = item;

  return (
    <motion.div
      layout
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95, transition: { duration: 0.1 } }}
      transition={{ duration: AGENT_DURATIONS.fast, ease: AGENT_EASING.outExpo }}
      className="mb-2 min-w-0">
      <FileCard
        name={file.name}
        mimeType={mimeTypeForName(file.name)}
        sizeBytes={file.size}
        action={
          <TrackedButton
            type="button"
            variant="ghost"
            buttonName="AGENT_REMOVE_ATTACHMENT"
            onClick={() => onRemove(item.id)}
            aria-label={t('Agent.AttachmentRemove', { name: file.name })}
            title={t('Agent.AttachmentRemove', { name: file.name })}
            className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-md p-0 text-gray-400 cursor-pointer transition-colors duration-200 hover:bg-gray-200/60 hover:text-gray-700">
            <X size={14} strokeWidth={2} />
          </TrackedButton>
        }
      />
    </motion.div>
  );
};

export default AttachmentTile;
